module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"APIMatic Website","short_name":"APIMatic","start_url":"/","background_color":"#ffffff","theme_color":"#0c7ff2","display":"standalone","icon":"src/images/favicons/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"dfeaf1a9a40408a50d86f0d5d472888e"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
